import { firestore } from "../utils/firebase";

const customerDocument = (cafe, phone) =>
  firestore.collection(`Restaurants/${cafe}/users`).doc(phone);

const addressesMatch = (first = {}, second = {}) =>
  first.title === second.title &&
  (first.address ?? first.addres ?? "") ===
    (second.address ?? second.addres ?? "");

export const deleteCustomerAddress = async (cafe, phone, address) => {
  const reference = customerDocument(cafe, phone);

  return firestore.runTransaction(async (transaction) => {
    const snapshot = await transaction.get(reference);
    if (!snapshot.exists) throw new Error("Müşteri kaydı bulunamadı.");

    const customer = snapshot.data() || {};
    const addressList = Array.isArray(customer.addressList)
      ? [...customer.addressList]
      : [];
    const addressIndex = addressList.findIndex((item) =>
      addressesMatch(item, address)
    );

    if (addressIndex < 0) throw new Error("Adres kaydı bulunamadı.");

    addressList.splice(addressIndex, 1);
    const updatedCustomer = { ...customer, addressList };
    transaction.set(reference, updatedCustomer);
    return updatedCustomer;
  });
};
